<template>
  <section class="main-content clearfix">
    <Lefter ref="Lefter"></Lefter>
    <div class="right-container clearfix" ref="rightContainer">
      <BreadCrumbs></BreadCrumbs>
      <DetailContent ref="DetailContent" @loadData="loadData" @loadSy="loadSy" @hideSy="hideSy">
      </DetailContent>
    </div>
    <t-space class="affix" :class="{'affix-switch': true}">
      <t-affix ref="affix" :offset-top="140" :offset-bottom="140" :onFixedChange="onFixedChange">
        <div class="affix-wrap" :class="{'iconfont-disable': !showAffix}" @click="showAffix && goTop()">
          <div>
            <i class="iconfont icon-rule-top affix-icon"></i>
            <p>顶部</p>
          </div>
        </div>
      </t-affix>
    </t-space>
  </section>
</template>

<script>
import Lefter from './lefter.vue'
import BreadCrumbs from '../rule/breadCrumbs.vue'
import DetailContent from './detailContent.vue'
import $ from 'jquery'
import {mapState} from 'vuex'
export default {
  name: '',
  data () {
    return {
      showAffix: false
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapState('rule', {
      page: 'page'
    }),
    ...mapState({
      categoryId: 'categoryId',
      childCategoryId: 'childCategoryId'
    })
  },
  mounted () {

  },
  methods: {
    loadData () {
      this.$refs.Lefter.loadData()
    },
    onFixedChange () {
      // console.log(22, affixed, context, $(window).scrollTop())
      if ($(window).scrollTop() > 0) {
        this.showAffix = true
      } else {
        this.showAffix = false
      }
    },
    goBack () {
      this.$router.go(-1)
      /* this.$router.push({
        name: this.page === 'NoticeDetail' ? 'Notice' : 'Rule',
        query: {
          categoryId: this.categoryId,
          childCategoryId: this.childCategoryId
        }
      })*/
    },
    goTop () {
      // $(window).scrollTop(0)
      $("html, body").animate({
        scrollTop: 0
      }, 200)
    },
    loadSy () {
      var config = {
          tw: 160, //内容高度
          th: 150,  // 内容宽度
          c: 80 // 为了避免页面下方有多余的空白, 少显示一行。所以在计算每个水印高度的时候，需要加个差值，使水印分布的更均匀（一般为内容高度的一半即可）
      }
      var dom = document.getElementById('sy')
      dom.style.display = 'block'
      var data = {
          name: this.userInfo.username,
          code: '唯品会规则平台文件'
      }
      console.log(222, this.$refs.rightContainer, this.$refs.rightContainer.offsetWidth)
      var width = this.$refs.rightContainer.offsetWidth
      dom.style.width = width + "px"
      var height = this.$refs.rightContainer.offsetHeight
      dom.style.height = height + "px"
      var wnum = parseInt(width / config.tw) || 1
      var hnum = parseInt(height / config.th) || 1
      var wc = (width - wnum * config.tw) / wnum - 1 || 0
      var hc = (height - hnum * config.th + config.c) / hnum - 1 || 0
      var num = wnum * (hnum - 1)
      var html = []
      for (var i = 0; i < num; i++) {
          html.push('<div style="width: ' + (config.tw + wc) + 'px;height: ' + (config.th + hc) + 'px">', data.name, '<br/>', data.code, '</div>');
      }
      dom.innerHTML = html.join("")
    },
    hideSy () {
      var dom = document.getElementById('sy')
      dom.style.display = 'none'
    }
  },
  components: {
    Lefter,
    BreadCrumbs,
    DetailContent
  }
}
</script>

<style lang="scss" scoped>
.table-sy {
  width: 100%;
  height: 100%;
  position: absolute;
  pointer-events: none; /*主要是这个属性*/
  color:#d2d6d9;
  z-index: 1;
  left: 0;
  top: 0;
}
.table-sy :deep(div) {
  /*width: 300px;*/
  /*height: 150px;*/
  display: flex;
  align-items: center;
  justify-content: center;
  transform:rotate(-38deg);
  float: left;
  text-align: center;
}
.main-content {
  margin: 10px 0;
  position: relative;
  .right-container {
    margin-left: 248px;
    background: #fff;
    padding-left: 30px;
    padding-right: 30px;
    min-height: 495px;
    position: relative;
  }
  .affix {
    position: fixed;
    right: 10%;
    bottom: 20px;
    opacity: 1;
    &.affix-switch {
      opacity: 1;
    }
  }
  .affix-wrap {
    text-align: center;
    border-radius: 46px;
    width: 46px;
    height: 46px;
    box-sizing: border-box;
    cursor: pointer;
    color: #fff;
    background: rgba($color: #000, $alpha: 0.6);
    overflow: hidden;
    &:hover {
      font-weight: bold;
      .affix-icon {
        font-weight: bold;
      }
      & > div:not(:last-child) {
        border-bottom: 2px solid rgba($color: #f20480, $alpha: 0.7);
      }
    }
    .affix-icon {
      font-size: 20px;
    }
    &.iconfont-disable {
      display: none;
    }
    & > div {
      & > p {
        font-size: 12px;
        line-height: 14px;
        position: relative;
        top: -4px;
      }
    }
    & > div:not(:last-child) {
      border-bottom: 2px solid rgba($color: #f20480, $alpha: 0.4);
    }
  }
  :deep(.t-affix) {
    right: 10%;
    width:46px!important;
    height: auto !important;
  }
}
.print {
  position: absolute;
  left: 0;
  top: 20px;
  z-index: -1;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  opacity: 1;
  :deep(.download) {
    display: none;
  }
}
</style>
